import { useLoaderData } from '@remix-run/react';
import { PaginatedProducts } from '@modules/professional/component/products-tab/PaginatedProducts';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';
import { useTilesAdminData } from '~/modules-rocco/admin/hooks/use-tiles-admin-data';
import type { loader } from './loaders/our-products-page-loader.server';

const OurProductsPage = () => {
    const { searchResult, pagination, filterStates, productTilesRocco } =
        useLoaderData<typeof loader>();
    const disableTileLink = useIsDisabledInPreview('featured_tile_links');
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const disableSort = useIsDisabledInPreview('directory_sort');
    const productTilesRoccoAdmin = useTilesAdminData(productTilesRocco);

    return (
        <PaginatedProducts
            searchResult={searchResult}
            pagination={pagination}
            filterStates={filterStates}
            productTilesRocco={productTilesRoccoAdmin}
            disableTileLink={disableTileLink}
            disableSaveToDesignBoard={disableSaveToDesignBoard}
            disableSort={disableSort}
        />
    );
};

export default OurProductsPage;
